import InputItemList from '@shared/components/core/field/list/TextInputList';
import DeviceTypeModel from '@shared/models/devices/DeviceTypeModel';
import { useTranslation } from 'react-i18next';
import CreateDeviceTypeDialog from '../../deviceType/CreateDeviceTypeDialog';

interface IClientDeviceTypeEditorProps {
    value: string[];
    deviceOptions: DeviceTypeModel[];
    onUpdate: (field: 'authClientDeviceTypes', value: string[]) => void;
}

export default function ClientDeviceTypeEditor({ value, deviceOptions, onUpdate }: IClientDeviceTypeEditorProps) {
    const { t } = useTranslation();

    const selectOptions = deviceOptions.map((device) => ({
        value: device.id,
        label: device.name,
    }));

    return (
        <InputItemList
            initialValues={value}
            legend={t('common:organization.projects.deviceScopes.titleLong')}
            description={t('common:organization.projects.deviceScopes.description')}
            selectOptions={selectOptions}
            onChange={(updatedDevices) => onUpdate('authClientDeviceTypes', updatedDevices)}
            dialogComponent={({ open, index, onClose, onCreated }) => (
                <CreateDeviceTypeDialog open={open} index={index} onClose={onClose} onCreated={onCreated} />
            )}
            createNewItemLabel={t('common:organization.projects.deviceScopes.action')}
        />
    );
}
